module.exports = __webpack_public_path__ + "img/smart.858ac516.svg";